<template>
  <div class="messages_body">
    <div v-for="(m, i) in messages"
         :class="{closeLine:m.type === 3,income: m.type === 1, message: true, system_message: m.type === 4}">
      <template v-if="m?.message_data?.file_path">
        <template v-if="!m.file_link">
          <div class="empty_image">
            <LoadingButton
              title='<i class="icon-fa icon-fa-refresh"/>'
              :loading="imageLoading[m.message_data.file_path]"
              :color="$constants.SUCCESS_COLOR"
              :onClick="() => getImagePath(m, i)"
              className="btn btn-default"
            />
          </div>
        </template>
        <template v-else>
          <img :src="m.file_link" alt="">
        </template>
      </template>
      <template v-if="m.drug_id">
        <p v-if="m.message_data?.message_data?.text_on_reply">{{ m.message_data?.message_data?.text_on_reply }}</p>
        <p>{{ m.message }} {{ m.message_data.title }} <strong>{{ m.message_data.price }}</strong></p>
      </template>
      <template v-else>
        <div class="message_div" v-html="m.message"/>
        <div v-if="m.message_data?.url"><a :href="m.message_data.url" target="_blank">страница с который был создан
          чат</a></div>
      </template>
      <div class="flex fs-12 justify-content-end"><span class="text-muted">{{ printDate(m.created_at) }}</span>
        <template v-if="m.type === 1">
          <v-popover
            class="ml-1 read_icon"
            :auto-hide="true"
            placement="right"
          >
            <i class="icon-fa icon-fa-check-circle"></i>
            <template slot="popover">
              <div class="flex" v-for="(r, uId) in m.read_by">
                {{ printDate(r) }}
                <UserName :id="uId"/>
              </div>
            </template>
          </v-popover>
        </template>
      </div>
      <p class="text-muted" v-if="[2,3,4].includes(m.type)">
        <UserName :id="m.user_id"/>
      </p>
    </div>
  </div>
</template>

<script>

import UserName from "@/components/users/UserName.vue";
import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton.vue";

export default {
  components: {UserName, LoadingButton},
  props: ['messages', 'loadedImages', 'updateLoadedImages'],
  data() {
    return {
      imageLoading: {},
      readMessagesTask: null,
    }
  },
  created() {
    this.updateImageLinks();
    this.updateReadMessages();
  },
  beforeDestroy() {
    console.log('destroy');
    clearTimeout(this.readMessagesTask);
  },
  methods: {
    async updateReadMessages() {
      this.readMessagesTask = setTimeout(async () => {
        const messages = this.messages.filter((m) => !m.read_by || !m.read_by[this.$currentUID]);
        if (messages.length) {
          console.log('update messages');
          const {data} = await api.post('/clientChats/updateMessages', {
            messages: messages.map((m) => m.id)
          })
        }
      }, 4000);
    },
    async updateImageLinks() {
      if (this.loadedImages) {
        let index = 0;
        for (const m of this.messages) {
          if (m?.message_data?.file_path && this.loadedImages[m.message_data.file_path]) {
            this.messages[index].file_link = this.loadedImages[m.message_data.file_path];
          }
          ++index;
        }
      }
    },
    async getImagePath(message, index) {
      this.imageLoading[message.message_data.file_path] = true;
      this.imageLoading = {...this.imageLoading};
      let {data} = await api.index('/uploads/getImgLinkByKey?key=' + message.message_data.file_path);
      if (!data.success) {
        toastr['warning'](data.message || 'Ошибка');
        return;
      }
      this.messages[index].file_link = data.link;
      if (this.loadedImages) {
        if (this.updateLoadedImages) {
          this.updateLoadedImages({
            ...this.updateLoadedImages,
            [message.message_data.file_path]: this.messages[index].file_link
          });
        }
      }
      this.imageLoading[message.message_data.file_path] = false;
    }
  }
}

</script>

<style scoped>
.message {
  padding: 3px 15px;
  text-align: right;
  border: 1px solid #ececec;
  margin: 0 3px 3px 3px;
  background-color: #cfffff;
  max-width: 75%;
  align-self: end;
  width: fit-content;
}

.message p {
  margin-bottom: 2px;
}

.message img {
  width: 100%;
}

.message p.text-muted {
  text-align: right;
  font-size: 12px;
}

.message.closeLine {
  width: 100%;
  text-align: center;
}

.message.income {
  background-color: #fff;
  text-align: left;
  align-self: start;
}

.messages_body {
  background-color: #f8f8f8;
  height: 100%;
  display: flex;
  flex-direction: column-reverse;
  overflow: auto;
}

.message_div {
  white-space: break-spaces;
}

.system_message {
  border: 2px solid #00db00;
  background-color: white;
}

.read_icon {
  cursor: pointer;
}
</style>
